// extracted by mini-css-extract-plugin
export var component = "Button-module--component--RWfbP";
export var inert = "Button-module--inert--+6CjQ";
export var label = "Button-module--label--sm91I";
export var current = "Button-module--current--2H09R";
export var icon = "Button-module--icon--9BCaK";